import {useRef} from 'react';
import {useModalControls} from './use-modal-controls';

export const usePromisedModalControls = () => {
  const {closeModal, isOpen, openModal} = useModalControls();
  const resolveRef = useRef<(value: boolean | PromiseLike<boolean>) => void>();

  const openModalWithPromise = async () => {
    openModal();
    return new Promise<boolean>(resolve => {
      resolveRef.current = resolve;
    });
  };

  return {
    isOpen,
    openModal: openModalWithPromise,
    closeModal,
    resolveRef,
  };
};
